"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NoteRequest = /** @class */ (function () {
    function NoteRequest() {
    }
    return NoteRequest;
}());
exports.default = NoteRequest;
//# sourceMappingURL=NoteRequest.js.map